import { Typography, Paper } from '@mui/material'
import { SANCTION_SOURCES } from '../../KybSanctionsSummary/sanctionsSources'
import { useTranslation } from 'react-i18next'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import TimelineDotLine from '../components/TimelineDotLine'

const SanctionsSummaryPdf = ({ checkDetails }) => {
  const { t } = useTranslation(['common'])
  const sourceHits = {}

  if (Array.isArray(checkDetails?.SanctionsHistory)) {
    checkDetails.SanctionsHistory.forEach((entry) => {
      const sourceKey = entry.Source?.toLowerCase?.().trim()
      if (sourceKey) {
        sourceHits[sourceKey] = true
      }
    })
  }

  const sanctionItems = Object.entries(SANCTION_SOURCES).map(([key, label]) => ({
    label,
    isHit: !!sourceHits[key],
    key,
  }))

  return (
    <TimelineDotLine>
      <Paper elevation={0} variant="rootOutlined" sx={{ flex: 1 }}>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem', position: 'relative' }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {t('common:sanctions')} - {t('common:sources')}
          </Typography>
          
          <div style={{ 
            backgroundColor: '#f8f9fa',
            padding: '0.3rem 0.4rem',
            border: '1px solid #dee2e6',
            fontSize: '0.65rem',
            marginLeft: '1rem'
          }}>
            <Typography variant="caption" sx={{ fontWeight: 500, display: 'block', mb: 0.2, fontSize: '0.65rem', color: '#495057', lineHeight: 1.2 }}>
              {t('common:analyticsLegend')}:
            </Typography>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.1rem' }}>
              <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: '0.2rem', fontSize: '0.6rem', color: '#495057', lineHeight: 1.2 }}>
                <CheckIcon sx={{ color: 'success.main', fontSize: '1.2rem' }} />
                <span>{t('common:noRecordsFound')}</span>
              </Typography>
              <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: '0.2rem', fontSize: '0.6rem', color: '#495057', lineHeight: 1.2 }}>
                <CloseIcon sx={{ color: 'error.main', fontSize: '1.2rem' }} />
                <span>{t('common:exposureIdentified')}</span>
              </Typography>
            </div>
          </div>
        </div>
        
        <div className="c-detail-grid">
          {sanctionItems.map((item, index) => (
            <div key={index} className="c-detail-row" style={{ alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flex: '1' }}>
                {item.isHit ? (
                  <CloseIcon sx={{ color: 'error.main', fontSize: '1.2rem' }} />
                ) : (
                  <CheckIcon sx={{ color: 'primary.main', fontSize: '1.2rem' }} />
                )}
                <span>{item.label}</span>
              </Typography>
            </div>
          ))}
        </div>
      </Paper>
    </TimelineDotLine>
  )
}

export default SanctionsSummaryPdf

